<template>
  <div class="opc-succezz-layout" role="main">
    <div class="opc-succezz-layout__top__inner">
      <slot />
    </div>
    <div class="opc-succezz-layout__order-details" v-show="false">
      <slot name="details" />
    </div>
    <div class="opc-succezz-layout__bottom" v-show="false">
      <div class="opc-succezz-layout__bottom__inner">
        <slot name="promotes" />
      </div>
    </div>
  </div>
</template>

<script>
import '@/styles/modal-iframe-override.scss';

import {
  showModalDialogCloseButton,
  modalHybrid,
  watchThemeChange,
  closeiFrameContainerLoading,
} from '@/utils/modal-utils.js';

export default {
  created() {
    if (modalHybrid.isInWebview) {
      watchThemeChange();
    }
  },
  mounted() {
    document.body.classList.add('opc-succezz__body', 'opc-modal');

    closeiFrameContainerLoading();
    showModalDialogCloseButton();
  },
};
</script>

<style lang='scss'>
@import './style/header.scss';
</style>

<style lang='scss' scoped>
@import '@/styles/_variables.scss';

.opc-succezz-layout {
  padding: $mobile-space;

  &__top {
    background: #fff;

    &__inner {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 100%;
      padding: 64px;
    }
  }

  &__bottom {
    &__inner {
      margin: 0 auto;
    }
  }
}
</style>
